import styled from 'styled-components';

export const ErrorContainer = styled.div`
  padding: 1rem;
  background: #ffecec;
  color: #a00;

  pre {
    white-space: pre-wrap;
  }
`;
